// This is just a placeholder file for the 'Print' theme.
// View source the files in the `source/templates` directory for the actual templates used in the Print theme.

module.exports = (
	{
		TemplatePrefix: 'PictProvider-Theme-Print',
		Templates: [],
	}
);
